import useToggle from "common/hooks/useToggle"
import ArticuloService from "features/Inventario/services/ArticuloService"
import CategoriaService from "features/Inventario/services/CategoriaService"
import { useTaxes } from "features/User/pages/Taxes/useTaxes"
import { useDispatch } from "hooks/useDispatch"
import { useSelector } from "hooks/useSelector"
import { useCallback, useEffect, useState } from "react"
import {
  getConceptosIDSelector,
  newDocumentoSelector,
} from "../redux/selectors/newDocumentoSelectors"
import {
  addConcepto,
  deleteConcepto,
  incrementCantidadToConcepto,
  newDocumentoSelectorDoc,
  recalculate,
  setCantidad,
} from "../redux/slices/newDocumentoSlice"

const generateGetArticulos = ({
  filters,
  isLibrado,
  NIF,
}: $TSMigrationFixMe) => {
  return isLibrado
    ? () =>
        ArticuloService.getByNif({
          NIF,
          ...filters,
        })
    : () =>
        ArticuloService.getByFiltersConcepto({
          ...filters,
        })
}

const useNewProducts = ({
  hide,
  isLibrado,
  initialEmpresa,
}: $TSMigrationFixMe) => {
  const [articulos, setArticulos] = useState([])
  const [loadingArticulos, setLoadingArticulos] = useState(true)
  const [loadingMoreArticulos, setLoadingMoreArticulos] = useState(false)
  const [categorias, setCategorias] = useState([])
  const [showModalArticulosSelected, toggleShowModalArticulosSelected] =
    useToggle(false)
  // @ts-expect-error TS(2554): Expected 1 arguments, but got 0.
  const { taxes } = useTaxes()

  const { conceptos, subtotal, librado, librador } =
    useSelector(newDocumentoSelector)
  const articulosIdSelected = useSelector(getConceptosIDSelector)
  const dispatch = useDispatch()
  const objetoDocumento = useSelector(newDocumentoSelectorDoc)

  useEffect(() => {
    if (isLibrado && initialEmpresa?.cif) {
      CategoriaService.getAllPadresByNif(initialEmpresa?.cif).then(({ data }) =>
        setCategorias(data)
      )
    } else if (!isLibrado) {
      CategoriaService.getAllPadres().then(({ data }) => setCategorias(data))
    }
  }, [isLibrado, initialEmpresa])

  const handleGenerarPresupuesto = () => {
    dispatch(recalculate())
    hide()
  }

  const getArticulos = useCallback(
    async (filters = {}) => {
      if (isLibrado && !initialEmpresa?.cif) return

      const getArticulosFn = generateGetArticulos({
        isLibrado,
        NIF: initialEmpresa?.cif,
        filters,
      })

      // @ts-expect-error TS(2339): Property 'loadingMoreArticulos' does not exist on ...
      setLoadingArticulos(!filters.loadingMoreArticulos)
      // @ts-expect-error TS(2339): Property 'loadingMoreArticulos' does not exist on ...
      setLoadingMoreArticulos(filters.loadingMoreArticulos)

      getArticulosFn()
        .then((res) => {
          const items = res.data?.items
          setArticulos((prevArticulos) =>
            // @ts-expect-error TS(2339): Property 'loadingMoreArticulos' does not exist on ...
            filters?.loadingMoreArticulos ? [...prevArticulos, ...items] : items
          )
          // @ts-expect-error TS(2339): Property 'loadingMoreArticulos' does not exist on ...
          if (!items?.length && !filters?.loadingMoreArticulos)
            handleGenerarPresupuesto()
        })
        .finally(() => {
          setLoadingArticulos(false)
          setLoadingMoreArticulos(false)
        })
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [isLibrado, initialEmpresa]
  )

  const addArticulo = useCallback(
    (articulo: $TSMigrationFixMe) => {
      const userTaxeSelected = taxes.find(
        ({ tipo, valor }) =>
          tipo === (objetoDocumento.isLibrado ? 0 : 1) && valor === 21
      )
      dispatch(
        addConcepto({
          ...articulo,
          cantidad: 1,
          // @ts-expect-error TS(2532): Object is possibly 'undefined'.
          impuestoArticuloTipoId: userTaxeSelected.id,
          // @ts-expect-error TS(2532): Object is possibly 'undefined'.
          impuestoArticuloPorcentaje: userTaxeSelected.valor,
        })
      )
      dispatch(recalculate())
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [dispatch, taxes, librador, librado]
  )

  const removeArticulo = useCallback(
    (articulo: $TSMigrationFixMe) => {
      dispatch(deleteConcepto(articulo))
      dispatch(recalculate())
    },
    [dispatch]
  )

  const agregarCantidad = useCallback(
    ({ articulo, sum = 1 }: $TSMigrationFixMe) => {
      if (articulo.cantidad + sum === 0) {
        removeArticulo(articulo)
      } else {
        // @ts-expect-error TS(2345): Argument of type...
        dispatch(incrementCantidadToConcepto({ articulo, sum }))
      }
      dispatch(recalculate())
    },
    [dispatch, removeArticulo]
  )

  const handleChangeCantidad = useCallback(
    ({ cantidad, articulo }: $TSMigrationFixMe) => {
      if (+cantidad <= 0) {
        removeArticulo(articulo)
      } else {
        // @ts-expect-error TS(2345): Argument of type...
        dispatch(setCantidad({ cantidad: +cantidad, articulo }))
      }

      dispatch(recalculate())
    },
    [dispatch, removeArticulo]
  )

  return {
    articulos,
    toggleShowModalArticulosSelected,
    showModalArticulosSelected,
    categorias,
    loadingArticulos,
    cantidadArticulos: conceptos.length,
    precioTotal: subtotal,
    articulosIdSelected,
    loadingMoreArticulos,
    removeArticulo,
    getArticulos,
    addArticulo,
    handleGenerarPresupuesto,
    agregarCantidad,
    handleChangeCantidad,
  }
}

export default useNewProducts
